import React, { useCallback } from 'react';
import { Handle, Position } from 'reactflow';
import { 
  Box,
  Slider,
  Typography
} from '@mui/material';

export const RelationshipNode = ({ data, selected, id }) => {
  const handleChange = useCallback((event, value) => {
    event.stopPropagation();
    data.onChange?.(value);
  }, [data]);

  return (
    <div className="react-flow__node-default" style={{ minWidth: 250 }}>
      <Handle
        type="target"
        position={Position.Left}
        style={{ 
          left: 0,
          top: 24,
          transform: 'translateY(-50%)'
        }}
      />
      
      <div className="condition-label">
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          width: '100%'
        }}>
          <Typography variant="body2">Relationship</Typography>
          <Typography variant="body2" color="white" className={data.value > 0 ? 'relationship-true' : 'relationship-false'} sx={{ padding: '0 6px', borderRadius: 1 }}>
            {data.value > 0 ? `+${data.value}` : data.value}
          </Typography>
        </Box>
      </div>

      <Box sx={{ 
        padding: 2, 
        paddingTop: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 1
      }}>

        <Slider
          value={data.value || 0}
          onChange={handleChange}
          step={1}
          min={-20}
          max={20}
          className="nodrag"
          onMouseDown={e => e.stopPropagation()}
        />
      </Box>

      <Handle
        type="source"
        position={Position.Right}
        id="true"
        style={{
          right: 0,
          top: 24,
          transform: 'translateY(-50%)'
        }}
      />
    </div>
  );
}; 